import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscriber } from 'rxjs/Subscriber';
import { ApiService, ContractService } from '../../_services';
import { IContract, IChangeCallback } from '../../_entities';
import { IDataAccessEvent, CrudOperation } from "../../_entities/data";
import { ContractBase } from "./contract.base";

@Component({
	selector: 'contract-general-info',
	template: require('./contract-general-info.template.html'),
	styles: ['h3 { margin-top: 5px;margin-bottom: 20px }']
})
export class ContractGeneralInfoComponent extends ContractBase implements OnInit {

	private onContractChangedEvent: Subscriber<IDataAccessEvent<IContract>>;


	constructor(
		private readonly router: Router,
		private readonly route: ActivatedRoute,
		protected readonly contractService: ContractService,
		private api: ApiService) {
		super(contractService);

		this.onContractChangedEvent =
			this.contractService.itemChanged.subscribe(
				(evt: IDataAccessEvent<IContract>) => this.onContractChange(evt));
	}

	onContractChange(evt: IDataAccessEvent<IContract>) {
		if (evt.operation === CrudOperation.Create || evt.operation === CrudOperation.Delete) {
			this.router.navigate(["contracts"], { relativeTo: this.route.parent });
		}
	}


	ngOnInit(): void {
		this.api.profile.get().then(p => this.userProfile = p);
	}

	ngOnDestroy(): void {
	}

	userProfile;

	public onFollow(event: IChangeCallback<any>, projectId: number) {
		const index = this.userProfile.myContracts.indexOf(projectId, 0);

		if (index == -1) {
			this.userProfile.myContracts.push(projectId);
		}

		this.api.profile.save(this.userProfile).then(p => {
			this.userProfile = p;
			event.resolve();
		}, error => {
			event.reject(error);
		});
	}

	public onUnFollow(event: IChangeCallback<any>, projectId: number) {
		const index = this.userProfile.myContracts.indexOf(projectId, 0);
		if (index > -1) {
			this.userProfile.myContracts.splice(index, 1);
		}

		this.api.profile.save(this.userProfile).then(p => {
			this.userProfile = p;
			event.resolve();
		}, error => {
			event.reject(error);
		});
	}

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-general-info.component.ts